import { defineMessages } from 'react-intl';

export default defineMessages({
    CardHolderName: {
        id: 'cep.components.sgPolicyPaymentTile.CardHolderName',
        defaultMessage: 'Card Holder Name'
    },
    CardNumber: {
        id: 'cep.components.sgPolicyPaymentTile.CardNumber',
        defaultMessage: 'Card number'
    },
    ExpiryDate: {
        id: 'cep.components.sgPolicyPaymentTile.ExpiryDate',
        defaultMessage: 'Expiry date'
    },
    UsedForAutoRenewal: {
        id: 'cep.components.sgPolicyPaymentTile.UsedForAutoRenewal',
        defaultMessage: 'Automatic Renewal?'
    },
    Amend: {
        id: 'cep.components.sgPolicyPaymentTile.Amend',
        defaultMessage: 'Amend'
    },
    Save: {
        id: 'cep.components.sgPolicyPaymentTile.Save',
        defaultMessage: 'Save'
    },
    Yes: {
        id: 'cep.components.sgPolicyPaymentTile.Yes',
        defaultMessage: 'Yes'
    },
    No: {
        id: 'cep.components.sgPolicyPaymentTile.No',
        defaultMessage: 'No'
    }
});
